<ind-section-header [viewData]="productsKeyMessagesHeaderModel" (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
<ind-form-field [viewData]="productsSearchField" (handleAdditionalControls)="onFieldControlClick($event)"></ind-form-field>
<ion-reorder-group class="reorder-group-wrapper"
  [ngClass]="{'empty-list':!filteredSavedProducts.length}" 
  [disabled]="!(!activityService.selectedActivity.isCompleted && !isReadOnlyJointMeeting && !enableReadonlyViewForMeetings && !backgroundUploadInProgress && !activityService.selectedActivity?.isDiffPosition)" 
  (ionItemReorder)="reorderData($event.detail)">
    <div *ngFor="let product of filteredSavedProducts; trackBy: trackById">
        <ion-item *ngIf="filteredSavedProducts.length > 0">
            <div class="product-key-msg-wrapper">
                <div class="product-wrapper">
                    <div>
                        <span size="25" class="key-message-text">{{product.name}}</span>
                    </div>
                </div>
                <div class="key-messages-wrapper" *ngIf="product.keyMessages && product.keyMessages.length != 0">
                    <div class="keyMessage-container">
                        <span *ngFor="let keyMessage of product.keyMessages; trackBy: trackById" (click)="updatedHighlightedKeyMessage($event ,  product , keyMessage)" [attr.disabled]="activityService.selectedActivity.isCompleted || isReadOnlyJointMeeting || enableReadonlyViewForMeetings || backgroundUploadInProgress || activityService.selectedActivity?.isDiffPosition" id="{{product.ID + '-' + keyMessage.ID}}"
                            class="customized-button"
                            [ngClass]="{'selected':keyMessage.isSelected && !keyMessage.isAutoSelected,
                                        'auto-selected': keyMessage.isAutoSelected}">
                            {{keyMessage.name}}
                        </span>
                    </div>
                </div>
            </div>
            <ion-button *ngIf="product.isSelected && !product.isAutoSelected && !activityService.selectedActivity.isCompleted && !isReadOnlyJointMeeting && !enableReadonlyViewForMeetings && !backgroundUploadInProgress && !activityService.selectedActivity?.isDiffPosition" 
              fill="clear" slot="end" 
              (click)="removeSavedProduct($event, product)" 
              [disabled]="!(!activityService.selectedActivity.isCompleted && !isReadOnlyJointMeeting && !enableReadonlyViewForMeetings && !backgroundUploadInProgress && !activityService.selectedActivity?.isDiffPosition)">
              <ion-icon name="close-outline" class="remove-saved-product"></ion-icon>
            </ion-button>
            <ion-reorder slot="end"></ion-reorder>
        </ion-item>
    </div>
</ion-reorder-group>
